import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Rental } from '../../../core/models/rental.model';

@Component({
  selector: 'app-rental-delete-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './rental-delete-dialog.component.html',
  styleUrl: './rental-delete-dialog.component.scss',
})
export class RentalDeleteDialogComponent {
  readonly data = inject<{ rental: Rental }>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<RentalDeleteDialogComponent, boolean>>(MatDialogRef);
}
